<script>
  import Chart from 'chart.js'
  import { generateChart } from 'vue-chartjs'
  import { merge } from 'lodash'

  // Idea from https://stackoverflow.com/a/39118152 and modernized and extended to be configurable and having a label
  Chart.defaults.lineWithAverage = Chart.defaults.line
  Chart.controllers.lineWithAverage = Chart.controllers.line.extend({
    initialize () {
      Chart.controllers.line.prototype.initialize.apply(this, arguments)
    },
    draw () {
      const hasAverageConfigKey = Object.prototype.hasOwnProperty.call(this.chart.chart.options, 'average')
      const averageConfig = {
        averageLineColor: '#979797',
        averageLabelColor: '#000000',
        averageLabelFunction: (value) => value,
        averageValue: undefined,
        ...(hasAverageConfigKey ? this.chart.chart.options.average : {})
      }

      Chart.controllers.line.prototype.draw.apply(this, arguments)

      const sum = this.getDataset().data.reduce((carry, value) => carry + value, 0)

      // If no manual average is set calculate it from the datapoints
      const average = averageConfig.averageValue !== undefined
        ? averageConfig.averageValue
        : sum / this.getDataset().data.length

      const averageCoord = this.calculatePointY(average)

      this.chart.chart.canvas.ctx = this.chart.chart.canvas.getContext('2d')
      this.chart.chart.canvas.ctx.beginPath()
      this.chart.chart.canvas.ctx.moveTo(0, averageCoord)
      this.chart.chart.canvas.ctx.strokeStyle = averageConfig.averageLineColor
      this.chart.chart.canvas.ctx.lineTo(this.chart.chart.width, averageCoord)
      this.chart.chart.canvas.ctx.stroke()

      this.chart.chart.canvas.ctx.moveTo(this.chart.chart.width, averageCoord)
      this.chart.chart.canvas.ctx.fillStyle = averageConfig.averageLabelColor
      this.chart.chart.canvas.ctx.textAlign = 'right'
      this.chart.chart.canvas.ctx.fillText(averageConfig.averageLabelFunction(average), this.chart.chart.width - 4, averageCoord - 4)
    }
  })

  const lineWithAverage = generateChart('line-with-average', 'lineWithAverage')

  const defaultOptions = {
    maintainAspectRatio: false,
    layout: {
      padding: {
        top: 1,
        bottom: 1
      }
    },
    hover: {
      intersect: false,
      mode: 'label'
    },
    tooltips: {
      intersect: false,
      mode: 'label',
      displayColors: false
    },
    legend: {
      display: false
    },
    elements: {
      line: {
        borderWidth: 2,
        cubicInterpolationMode: 'monotone'
      },
      point: {
        radius: 0,
        hoverRadius: 4,
        pointStyle: 'round'
      }
    },
    scales: {
      yAxes: [
        {
          display: false,
          ticks: {
            suggestedMin: 0
          }
        }
      ],
      xAxes: [
        {
          display: false
        }
      ]
    }
  }

  export default {
    name: 'SparklineWithAverage',
    extends: lineWithAverage,
    props: {
      chartdata: {
        type: Object,
        default: null
      },
      options: {
        type: Object,
        default: null
      }
    },
    watch: {
      chartdata () {
        this.renderChart(this.chartdata, merge({}, this.options, defaultOptions))
      }
    },
    mounted () {
      this.renderChart(this.chartdata, merge({}, this.options, defaultOptions))
    }
  }
</script>
